import React from "react";
import DashboardOtherServicesMonthly from "./DashboardOtherServicesMonthly";

const DashboardV2OtherServicesMonthly = ({ user, dateSelection }) => (
  <DashboardOtherServicesMonthly user={user} dateSelection={dateSelection} />
);

export default DashboardV2OtherServicesMonthly;
